import anime from '../libs/anime'
import Hammer from '../libs/hammer'

class Module15Temoignage {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.slider = document.querySelectorAll('.module-15-temoignage .slider-temoignage');
    }

    let registerEvents = () => {
        for (let i = 0; i < cache.slider.length; i++) {
            cache.slider[i].parentNode.querySelector('.arrow-left').addEventListener('click', slideLeft);
            cache.slider[i].parentNode.querySelector('.arrow-right').addEventListener('click', slideRight);
            let slides = cache.slider[i].querySelectorAll('.slide');
            cache.slider[i].style.height = slides[0].offsetHeight + 'px';
            let bullets = cache.slider[i].parentNode.querySelectorAll('.bullet');
            for (let ii = 0; ii < slides.length; ii++) {
              slides[ii].addEventListener('click', clickSlide);
            }
            for (let ii = 0; ii < bullets.length; ii++) {
              bullets[ii].addEventListener('click', clickBullet);
            }
            let hammertime = new Hammer(cache.slider[i]);
            hammertime.on('swipe', function(ev) {
                if(ev.direction == 2) {
                  eventFire(hammertime.element.parentNode.querySelector('.arrow-right'), 'click');
                }
                if(ev.direction == 4) {
                  eventFire(hammertime.element.parentNode.querySelector('.arrow-left'), 'click');
                }
            });
        }
    }

    let clickSlide = function() {
        let slider = this.parentNode;
        let index = parseInt(slider.dataset.index);
        let nxt = this.nextSibling.nextElementSibling;
        let prev = this.previousSibling.previousElementSibling;
    
        if(nxt !== null) {
          let nxtI = parseInt(nxt.dataset.index);
        }
        else {
          let nxtI = 0;
        }
    
        if(prev !== null) {
          let prevI = parseInt(prev.dataset.index);
        }
        else {
          let prevI = parseInt(slider.querySelectorAll('.slide').length-1);
        }
    
        if(nxtI == index) {
          eventFire(slider.parentNode.querySelector('.arrow-left'), 'click');
        }
        else if(prevI == index) {
          eventFire(slider.parentNode.querySelector('.arrow-right'), 'click');
        }
      }
    
      let clickBullet = function() {
        if(!this.classList.contains('active')) {
          let bullet = this;
          let bulletI =  parseInt(bullet.dataset.index);
          let slider = bullet.parentNode.parentNode.querySelector(".slider-temoignage");
          let index = parseInt(slider.dataset.index);
          let nbBullets = bullet.parentNode.parentNode.querySelectorAll('.bullet').length;
    
          if(index > nbBullets-1) {
            index = index - nbBullets;
          }
    
          if((index-bulletI) < 0){
            // Right
            let nbclick = Math.abs(index-bulletI);
    
            for (let i = 0; i < nbclick; i++) {
              setTimeout(function(){ eventFire(bullet.parentNode.parentNode.querySelector('.arrow-right'), 'click'); }, (i * 400));
            }
          }
          else {
            // Right
            let nbclick = index-bulletI;
    
            for (let i = 0; i < nbclick; i++) {
              setTimeout(function(){ eventFire(bullet.parentNode.parentNode.querySelector('.arrow-left'), 'click');}, (i * 400));
            }
          }
    
        }
      }

    let slideLeft = function() {
        let slider = this.parentNode.querySelector(".slider-temoignage");
        let i = parseInt(slider.dataset.index);
        let slides = slider.querySelectorAll('.slide');
        let current = slides[i];
        let bullets = this.parentNode.querySelectorAll(".bullets_wrap .bullet");
        let bulletA = this.parentNode.querySelector(".bullets_wrap .bullet.active");
    
        bulletA.classList.remove('active');
    
        let prev;

        if(slides.length > 3) {
          if( i < slides.length-1) {
            prev = slides[i+1];
          }
          else {
            prev = slides[0];
          }
    
          anime({
            targets: prev,
            opacity: 0,
            translateX: ['65%','165%'],
            duration: 500,
            easing: 'easeInOutSine',
          });
        }
    
        if( i > 0) {
          i--;
        }
        else {
          i = slides.length-1;
        }
        slider.dataset.index = i;
        if(i > bullets.length-1) {
          bullets[(i - bullets.length)].classList.add('active');
        }
        else {
          bullets[i].classList.add('active');
        }
    
        let target = slides[i];
    
        if( i > 0) {
          i--;
        }
        else {
          i = slides.length-1;
        }
        let next = slides[i];
    
    
        anime({
          targets: current,
          opacity: 0.2,
          translateX: ['-50%', '65%'],
          duration: 500,
          easing: 'easeInOutSine',
        });
    
        anime({
          targets: target,
          opacity: 1,
          translateX: ['-165%', '-50%'],
          duration: 500,
          easing: 'easeInOutSine',
        });
    
        anime({
          targets: next,
          opacity: 0.2,
          translateX: ['-265%', '-165%'],
          duration: 500,
          easing: 'easeInOutSine',
        });

        anime({
          targets: slider,
          opacity: 1,
          height: target.offsetHeight,
          duration: 500,
          easing: 'easeInOutSine',
        });
    
      }
    
      let slideRight = function() {
        let slider = this.parentNode.querySelector(".slider-temoignage");
        let i = parseInt(slider.dataset.index);
        let slides = slider.querySelectorAll('.slide');
        let current = slides[i];
        let bullets = this.parentNode.querySelectorAll(".bullets_wrap .bullet");
        let bulletA = this.parentNode.querySelector(".bullets_wrap .bullet.active");
    
        bulletA.classList.remove('active');
        let prev;
        
        if(slides.length > 3) {
          if( i > 0) {
            prev = slides[i-1];
          }
          else {
            prev = slides[slides.length-1];
          }
    
          anime({
            targets: prev,
            opacity: 0,
            translateX: ['-165%','-265%'],
            duration: 500,
            easing: 'easeInOutSine',
          });
        }
    
        if( i < slides.length-1) {
          i++;
        }
        else {
          i = 0;
        }
        slider.dataset.index = i;
        if(i > bullets.length-1) {
          bullets[(i - bullets.length)].classList.add('active');
        }
        else {
          bullets[i].classList.add('active');
        }
    
        let target = slides[i];
    
        if( i < slides.length-1) {
          i++;
        }
        else {
          i = 0;
        }
        let next = slides[i];
    
        anime({
          targets: current,
          opacity: 0.2,
          translateX: ['-50%', '-165%'],
          duration: 500,
          easing: 'easeInOutSine',
        });
    
        anime({
          targets: target,
          opacity: 1,
          translateX: ['65%', '-50%'],
          duration: 500,
          easing: 'easeInOutSine',
        });
    
        anime({
          targets: next,
          opacity: 0.2,
          translateX: ['165%', '65%'],
          duration: 500,
          easing: 'easeInOutSine',
        });

        anime({
          targets: slider,
          opacity: 1,
          height: target.offsetHeight,
          duration: 500,
          easing: 'easeInOutSine',
        });
    
      }
    
    
      function eventFire(el, etype){
        if (el.fireEvent) {
          el.fireEvent('on' + etype);
        } else {
          let evObj = document.createEvent('Events');
          evObj.initEvent(etype, true, false);
          el.dispatchEvent(evObj);
        }
      }
    initFunc();
  }
}
export { Module15Temoignage }